import React, { useState } from 'react';
import './CustomizationForm.css';
import { useNavigate } from 'react-router-dom';
import ColorSelector from './ColorSelector';
import { BsBracesAsterisk } from "react-icons/bs";

function CustomizationForm(props) {
    const { customization, setCustomization, closeModal, addItemToCart, product, quantity } = props;
    const [loading, setLoading] = useState(false); // Estado para manejar la carga
    const [errors, setErrors] = useState({
        color: '',
        size: '',
        name: '',
        comments: '',
    });
    const [colorDisabled, setColorDisabled] = useState(false); // Estado para controlar el botón "No aplica"
    const navigate = useNavigate();

    // Función de validación
    const validateForm = () => {
        let isValid = true;
        let errorMessages = { color: '', size: '', name: '', comments: '' };

        if (customization.colors.length === 0 && !colorDisabled) { // Verificar si el color está deshabilitado
            errorMessages.color = 'Se debe seleccionar al menos un color.';
            isValid = false;
        }
        if (!customization.size) {
            errorMessages.size = 'El campo es requerido.';
            isValid = false;
        }
        if (!customization.name) {
            errorMessages.name = 'El campo es requerido.';
            isValid = false;
        }

        setErrors(errorMessages);
        return isValid;
    };

    // Manejo del envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (validateForm()) {
            console.log("Datos antes de enviar:", customization);
    
            setLoading(true);
    
            setTimeout(() => {
                setLoading(false);
    
                const productWithCustomization = {
                    ...product, // Datos del producto original
                    customization: customization, // Datos de personalización
                    quantity, // Usar la cantidad seleccionada del componente ProductDetails
                };
    
                console.log("Agregando al carrito:", product, "Cantidad:", quantity, "Personalización:", customization);
    
                // Aquí agregas el producto con personalización y cantidad al carrito
                addItemToCart(productWithCustomization);
    
                closeModal(); // Cierra el modal
                navigate('/cart', { state: { productWithCustomization } }); // Navega al carrito
            }, 2000);
        }
    };
    

    return (
        <form className="customization-form" onSubmit={handleSubmit}>
            <div className="customization">
                <label className='customization-label' for="color">¿Te gustaría personalizar el color?</label>
                <ColorSelector
                    customization={customization}
                    setCustomization={setCustomization}
                    setColorDisabled={setColorDisabled} // Pasar función para actualizar el estado de "No aplica"
                />
                {errors.color && <p className="error-message">{errors.color}</p>}
            </div>
            <div className="customization">
                <label for="size" className='customization-label'>¿Deseas un tamaño específico?</label>
                <input
                    placeholder="Ingresa el tamaño en cm (ej: 10, 25, 50)"
                    type="text"
                    value={customization.size}
                    onChange={(e) => setCustomization({ ...customization, size: e.target.value })}
                />
                {errors.size && <p className="error-message">{errors.size}</p>}
            </div>
            <div className="customization">
                <label for="name" className='customization-label'>¿Quieres agregar un nombre o logo personalizado?</label>
                <input
                    placeholder="Escribe el nombre o nombre del logo"
                    type="text"
                    value={customization.name}
                    onChange={(e) => setCustomization({ ...customization, name: e.target.value })}
                />
                {errors.name && <p className="error-message">{errors.name}</p>}
            </div>

            <div className="customization">
                <label for="comments" className='customization-label'>Comentarios adicionales</label>
                <textarea
                    placeholder="Si lo necesitas, puedes agregar aquí cualquier detalle o instrucción adicional."
                    value={customization.comments}
                    onChange={(e) => setCustomization({ ...customization, comments: e.target.value })}
                />
                {errors.comments && <p className="error-message">{errors.comments}</p>}
            </div>
            <p className="small-text"><BsBracesAsterisk /><small> Si no deseas personalizar, escribe "No Aplica" en los campos correspondientes. De lo contrario, ingresa lo que corresponda en cada campo.</small></p>
            <button className="button" type="submit" disabled={loading}>
                {loading ? (
                    <span className="loading-spinner">Cargando...</span>
                ) : (
                    'Agregar'
                )}
            </button>
        </form>
    );
}

export default CustomizationForm;
